/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ID, PrintEntryPoint } from '@gh/common-shared-data';
import { AbstractRestService, arrayOf, Enum, RestSettings, SlicedDataSource } from '@gh/core-data';
import { Observable } from 'rxjs';
import { JobSpecDetailsDto, JobSpecFilterDto } from './job-spec.dto';
import { JobSpecMapper } from './job-spec.mapper';
import { JobListFilterDto, JobListFilterMapper, JobListItemDto, JobListItemMapper } from '../jobs';
import { ENV_BASE_URL } from '@gh/config';

@Injectable()
export class JobSpecRestService extends AbstractRestService {

  constructor(settings: RestSettings) {
    super(settings);
  }

  create(jobSpec: JobSpecDetailsDto): Observable<JobSpecDetailsDto> {
    return this.httpPost(
      `${this.bp}/job-specification`,
      jobSpec,
      JobSpecMapper);
  }

  update(jobId: ID, jobSpec: JobSpecDetailsDto): Observable<JobSpecDetailsDto> {
    return this.httpPut(
      `${this.bp}/job-specification/${jobId}`,
      jobSpec,
      JobSpecMapper);
  }

  get(id: ID, filter: JobSpecFilterDto): Observable<JobSpecDetailsDto> {
    return this.httpGet(
      `${this.bp}/jobs/${id}/specs`,
      filter,
      JobSpecMapper,
      JobSpecMapper,
    );
  }

  save(id: ID, jobSpec: JobSpecDetailsDto): Observable<JobSpecDetailsDto> {
    return this.httpPut(
      `${this.bp}/jobs/${id}/specs`,
      jobSpec,
      JobSpecMapper,
    );
  }

  produce(id: ID, jobSpec: JobSpecDetailsDto, entryPoint: PrintEntryPoint): Observable<JobSpecDetailsDto> {
    return this.httpPut(
      `${this.bp}/jobs/${id}/specs/produce?entryPoint=${Enum.toValue(PrintEntryPoint, entryPoint)}`,
      jobSpec,
      JobSpecMapper,
    );
  }

  findAllAsDataSource(filter: JobListFilterDto): SlicedDataSource<JobListItemDto> {
    return this.createSlicedDataSourceGet(`${this.jad}/job-specifications`,
                                          filter, JobListFilterMapper, arrayOf(JobListItemMapper));
  }
}
